import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import baseLoginValidator from 'utils/validators/baseLoginValidator'
import emailValidator from 'utils/validators/emailValidator'
import * as Yup from 'yup'
import LoginField from '../subcomponents/LoginField'
import { useAccountCreateFormSubmit } from 'modules/Forms/Account/Create/useAccountCreateFormSubmit'
import SubmitButtons from 'modules/Forms/Account/Create/subcomponents/submitButtons'

export const YahooSchema = () =>
  Yup.object().shape({
    logins: Yup.array().of(Yup.object()),
    login: Yup.string().when('logins', ([logins], schema) =>
      logins
        ? schema.strip()
        : schema
            .test('baseLoginTest', '', baseLoginValidator)
            .required('common::validation_messages.required'),
    ),
    network: Yup.string().required('common::validation_messages.required'),
    email: Yup.string()
      .test(
        'isYahooDomain',
        'common::validation_messages.incorrect_email_format',
        function test(value) {
          let isValid

          const { path, createError } = this

          isValid = value.match(/(@yahoo\.com)$/)

          return (
            isValid ||
            createError({
              path,
              message:
                'services::forms.register_account.yahoo.fields.email.validation_messages.not_yahoo_domain',
            })
          )
        },
      )
      .test('emailValidator', 'common::validation_messages.incorrect_email_format', emailValidator)
      .required('common::validation_messages.required'),
  })

let CreateYahooForm = ({
  handleSubmit,
  submitting,
  onClose,
  autofill,
  formHeader,
  form,
  networkId,
  array,
  multiLogins,
}) => {
  const { t } = useTranslation()
  const submitAccountData = useAccountCreateFormSubmit(form, onClose, multiLogins)

  useEffect(() => {
    if (networkId) {
      autofill('network', networkId)
    }
  }, [networkId])

  return (
    <>
      {formHeader}

      <form
        onSubmit={handleSubmit(submitAccountData)}
        noValidate
      >
        <Field
          disabled
          name="network"
          hidden
          fullWidth
          component={renderInputField}
          t={t}
        />

        <div className={'margin-bottom-16'}>
          <LoginField
            form={form}
            multiLogins={multiLogins}
            array={array}
            autofill={autofill}
            networkId={networkId}
            label={'services::forms.register_account.yahoo.fields.login.label'}
          />
        </div>

        <div className={'margin-bottom-16'}>
          <Field
            name="email"
            type="email"
            fullWidth
            component={renderInputField}
            label={t('services::forms.register_account.yahoo.fields.email.label')}
            t={t}
          />
        </div>

        <SubmitButtons
          submitting={submitting}
          onClose={onClose}
        />
      </form>
    </>
  )
}

CreateYahooForm = reduxForm({
  form: 'CreateYahooForm',
  initialValues: {
    login: '',
    network: '',
    email: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
})(CreateYahooForm)

CreateYahooForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  valid: PropTypes.bool,
  autofill: PropTypes.func,
  networkType: PropTypes.string,
  form: PropTypes.string,
  networkId: PropTypes.string,
  multiLogins: PropTypes.bool,
  array: PropTypes.object,
  formHeader: PropTypes.node,
}

export default CreateYahooForm
